import { createRoot } from 'react-dom/client'
import LogRocket from 'logrocket';
import App from './App.tsx'
import './index.css'

// Initialize LogRocket
// Sourcemaps are automatically detected if accessible at the same origin as JS files
// Or upload them manually using: logrocket upload-sourcemaps --app-id r6ynch/tcf-exam ./dist
LogRocket.init('r6ynch/tcf-exam');

createRoot(document.getElementById("root")!).render(<App />);
